import { Observable, map } from 'rxjs';

export function clone<T extends {} | null | undefined>(source: Observable<T>): Observable<T> {
  return source.pipe(map((data) => (data ? structuredClone(data) : data)));
}
